// Field template per schema type: which schema.org properties each type shows in the
// editor, in display order. When a schema is loaded/generated, present values are kept and
// any property listed here that is missing is rendered as an EMPTY input for manual entry.
// Empty fields are not written to the saved JSON-LD unless the editor fills them in.
//
// Keys must be valid schema.org property names (they become JSON-LD keys); their Danish
// labels live in ./labels.js (LABEL_TRANSLATIONS). Edit freely to add/remove/reorder fields.

export const TYPE_FIELDS = {
    MedicalWebPage: [
        "name", "headline", "description", "datePublished", "author",
        "reviewedBy", "lastReviewed", "medicalAudience", "about"
    ],
    MedicalScholarlyArticle: [
        "name", "headline", "description", "articleBody", "datePublished",
        "dateModified", "author", "publisher", "keywords", "citation"
    ],
    MedicalCondition: [
        "name", "alternateName", "description", "associatedAnatomy", "signOrSymptom",
        "cause", "riskFactor", "possibleTreatment", "possibleComplication",
        "primaryPrevention", "secondaryPrevention", "typicalTest", "stage",
        "expectedPrognosis", "epidemiology", "differentialDiagnosis", "pathophysiology"
    ],
    AnatomicalStructure: [
        "name", "description", "associatedPathophysiology", "bodyLocation",
        "connectedTo", "partOfSystem", "relatedCondition", "relatedTherapy", "subStructure"
    ],
    MedicalSignOrSymptom: [
        "name", "description", "cause", "possibleTreatment", "associatedAnatomy", "riskFactor"
    ],
    MedicalRiskFactor: [
        "name", "description", "increasesRiskOf"
    ],
    MedicalTest: [
        "name", "description", "usedToDiagnose", "normalRange", "signDetected",
        "affectedBy", "usesDevice"
    ],
    MedicalTherapy: [
        "name", "description", "indication", "contraindication", "adverseOutcome",
        "seriousAdverseOutcome", "duplicateTherapy"
    ],
    MedicalProcedure: [
        "name", "description", "procedureType", "bodyLocation", "howPerformed",
        "preparation", "followup", "status"
    ],
    Drug: [
        "name", "alternateName", "description", "activeIngredient", "administrationRoute",
        "dosageForm", "doseSchedule", "drugClass", "mechanismOfAction", "nonProprietaryName",
        "prescriptionStatus", "interactingDrug", "pregnancyCategory", "warning"
    ],
    MedicalGuideline: [
        "name", "description", "evidenceLevel", "evidenceOrigin", "guidelineDate",
        "guidelineSubject", "recommendationStrength"
    ],
    MedicalStudy: [
        "name", "description", "healthCondition", "sponsor", "status", "studyLocation",
        "studySubject", "studyDesign", "phase", "trialDesign"
    ],
    DietarySupplement: [
        "name", "description", "activeIngredient", "dosageForm", "mechanismOfAction",
        "nonProprietaryName", "recommendedIntake", "maximumIntake", "safetyConsideration",
        "targetPopulation", "background"
    ],
    Diet: [
        "name", "description", "dietFeatures", "endorsers", "expertConsiderations",
        "physiologicalBenefits", "risks"
    ],
    Recipe: [
        "name", "description", "recipeCategory", "recipeCuisine", "recipeIngredient",
        "recipeInstructions", "recipeYield", "prepTime", "cookTime", "totalTime",
        "nutrition", "suitableForDiet"
    ],
    Hospital: [
        "name", "description", "address", "telephone", "email", "openingHours",
        "medicalSpecialty", "availableService", "isAcceptingNewPatients"
    ],
    MedicalClinic: [
        "name", "description", "address", "telephone", "email", "openingHours",
        "medicalSpecialty", "availableService", "isAcceptingNewPatients"
    ],
    FAQPage: [
        "name", "description", "mainEntity"
    ]
}

// Properties that hold MULTIPLE values. When one of these is missing/empty it renders as an
// empty list (with a "Tilføj" button) instead of a single-line input, so the editor can add
// several entries. When present in the data it already renders as a list. Edit freely.
export const LIST_KEYS = [
    // MedicalCondition / symptoms
    "cause", "riskFactor", "possibleTreatment", "signOrSymptom", "typicalTest",
    "possibleComplication", "differentialDiagnosis", "primaryPrevention", "secondaryPrevention",
    "increasesRiskOf", "associatedAnatomy",
    // AnatomicalStructure
    "connectedTo", "relatedCondition", "relatedTherapy", "subStructure", "bodyLocation", "partOfSystem",
    // MedicalTest
    "signDetected", "usedToDiagnose", "affectedBy", "usesDevice",
    // MedicalTherapy / MedicalProcedure
    "indication", "contraindication", "adverseOutcome", "seriousAdverseOutcome", "duplicateTherapy",
    // Drug
    "interactingDrug", "activeIngredient", "administrationRoute", "drugClass", "warning",
    // MedicalGuideline
    "guidelineSubject",
    // MedicalStudy
    "healthCondition", "sponsor", "studyLocation", "studySubject",
    // DietarySupplement
    "safetyConsideration", "targetPopulation",
    // Hospital / MedicalClinic
    "availableService", "medicalSpecialty", "openingHours",
    // MedicalWebPage
    "medicalAudience",
    // Recipe
    "recipeIngredient", "recipeInstructions", "suitableForDiet",
    // Diet
    "dietFeatures", "endorsers", "expertConsiderations", "physiologicalBenefits", "risks",
    // Article / page
    "keywords", "citation", "about"
]
